import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { setVadFlowTypeOptions } from '../store/options.actions'

export function* getVadFlowTypeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getVadFlowTypeOptions])
    const { entity } = response
    yield put(setVadFlowTypeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getVadFlowTypeOptions() error: ${e}`))
  }
}
export function* getVadFlowTypeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getVadFlowTypeOptions)
}
